import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  background-color: #f0e2ff;
  background-image: url('/images/pantalla-feedback.png');
  background-repeat: no-repeat;
  background-position: left center;
  padding: 40px 16px 0;
  height: 100%;
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 32px;
  line-height: 125%;
  letter-spacing: -0.04em;
  color: #332927;
  margin-bottom: 8px;
`;

export const SimpleButton = styled(Button)``;

export const ButtonContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px;
`;
